export default __webpack_public_path__ + "static/media/listen_hero.8c6515e1.jpg";